import React from "react";
import { useNavigate, useLocation } from "react-router-dom";
import {
  HeaderContainer,
  HeaderLeftContainer,
  TypographyContainer,
  HeaderRightContainer,
} from "./Header.styled";
import { Typography, Button } from "@ann/web-components";

const Header = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const isRolesRoute = location.pathname.includes("/roles") && !location.pathname.includes("/create-role");

  const handleButtonClick = () => {
    if (isRolesRoute) {
      navigate("/v2/user-management/create-role");
    } else {
      navigate("/v2/user-management/invite-user");
    }
  };

  return (
    <HeaderContainer>
      <HeaderLeftContainer>
        <TypographyContainer>
          <Typography category="title" size="small" weight="bold">
            User Management
          </Typography>

          <Typography category="body" size="medium" weight="regular" color={"body"}>
            Add, manage, and monitor users, roles, and access to your workspace
          </Typography>
        </TypographyContainer>
      </HeaderLeftContainer>

      <HeaderRightContainer>
        <Button
          iconRight={isRolesRoute ? "plus" : "personAdd"}
          label={isRolesRoute ? "Create Role" : "Invite Users"}
          size="medium"
          type="gradient"
          onClick={handleButtonClick}
        />
      </HeaderRightContainer>
    </HeaderContainer>
  );
};

export default Header;

